export const endpoints = {
  authenticate: () => `/authenticate`,
  authenticateRefresh: () => `/authenticate/refresh`,
  createJob: () => `/job`,
  getAllSuppliers: () => `/supplier`,
  getAllSupplierLists: () => `/supplier/list`,
  getDownloadToken: (supplierId) => `/supplier/list/${supplierId}/downloadToken`,
  getDownload: (token) => `/supplier/list/download?token=${token}`,
}
